import React from "react";
import refrence from "../../scenes/Dashboard/reference";
import { useSelector } from "react-redux";

function EmployerWorkerViewProfile() {
  const publicInfo = useSelector(e => e.public);
  const pub = publicInfo.message?.profile;
  const userInfor = publicInfo.message?.user

  return (
    <div className="w-full tablet:w-[50%] py-8 bg-[#EFECFF] tablet:rounded-2xl flex justify-center px-[2%] tablet:px-[10%] ">
      {/* div for profile */}
      <div className="flex flex-col items-center gap-4 tablet:gap-9">
        {/* profile photo  */}
        <img
          src={userInfor?.profile_pics !== undefined ? userInfor?.profile_pics : refrence.profilephoto1}
          alt=""
          className="rounded-full h-20 w-20 tablet:h-40 tablet:w-40"
        />
        <div className=" flex flex-col gap-10 items-center ">
          {/* text content here  */}
          <div className="flex flex-col gap-3 items-center">
            <h2 className=" font-semibold tablet:text-2xl text-lg">
              {pub?.Fullname}
            </h2>
            <p className="font-semibold text-base text-[#898989]">
              {pub?.Job_type}
            </p>
          </div>
          {/* buttons  */}
          <div className="mt-4 tablet:mt-0 font-semibold text-base flex-row flex gap-2 tablet:gap-6">
            <button className=" bg-[#5843BD] border border-[#5843BD] hover:text-[#5843BD] hover:bg-[#E1DCF9] px-5 py-3 rounded-2xl text-[#ffffff] whitespace-nowrap">
              View Available Jobs
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployerWorkerViewProfile;